import { getSubscriptions } from "seneca-common/features/subscriptions/state/selectors";

import * as subscriptionSelectors from "../../../state/selectors/state/subscriptions/subscription";
import {
  subscriptionProductCanBeUpgraded,
  subscriptionProductHasAiAssistant,
  subscriptionProductHasAiQuizGeneration,
  subscriptionProductHasExamQuestions,
  subscriptionProductHasGuaranteedGrades,
  subscriptionProductHasQuizMode,
  subscriptionProductHasSmartLearning,
  subscriptionProductHasTutoring,
  subscriptionProductHasWrongAnswers
} from "../../subscription-products/selectors/subscriptionSubscriptionProduct";

export function premiumHasAccessToWrongAnswersMode(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasWrongAnswers
  );
}

export function premiumHasAccessToTutoring(state: any) {
  return doesPremiumHaveAccessToFeature(state, subscriptionProductHasTutoring);
}

export function premiumHasAccessToAiAssistant(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasAiAssistant
  );
}

export function premiumHasAccessToAiQuizGeneration(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasAiQuizGeneration
  );
}

export function premiumHasAccessToExamQuestions(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasExamQuestions
  );
}

export function premiumHasAccessToGuarantee(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasGuaranteedGrades
  );
}

export function premiumHasAccessToSmartLearning(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasSmartLearning
  );
}

export function premiumHasAccessToExamQuestion(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductHasExamQuestions
  );
}

export function premiumHasAccessToQuizMode(state: any) {
  return doesPremiumHaveAccessToFeature(state, subscriptionProductHasQuizMode);
}

export function premiumCanBeUpgraded(state: any) {
  return doesPremiumHaveAccessToFeature(
    state,
    subscriptionProductCanBeUpgraded
  );
}

export function getSubscriptionIdThatCanBeUpgraded(state: any) {
  const subscriptions = getSubscriptions(state);

  const subscriptionToUpgrade = subscriptions.find(subscription => {
    const subscriptionId =
      subscriptionSelectors.getSubscriptionId(subscription);

    const isLive = subscriptionSelectors.isLive(subscription);

    return (
      !!subscriptionId &&
      isLive &&
      subscriptionProductCanBeUpgraded(state, subscriptionId)
    );
  });
  if (subscriptionToUpgrade) {
    return subscriptionSelectors.getSubscriptionId(subscriptionToUpgrade);
  }
  return null;
}

function doesPremiumHaveAccessToFeature(
  state: any,
  selectorToCheckAccess: (state: any, subscriptionId: string) => boolean
) {
  const subscriptions = getSubscriptions(state);

  return subscriptions.some(subscription => {
    const subscriptionId =
      subscriptionSelectors.getSubscriptionId(subscription);

    const isLive = subscriptionSelectors.isLive(subscription);

    return (
      !!subscriptionId && isLive && selectorToCheckAccess(state, subscriptionId)
    );
  });
}
